export enum StorageEnum {
  AgentChatCategories = 'agent_chat_categories',
  Oauth2Result = 'oauth2_result',
}
